import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api-client';

export interface StudentMe {
  studentId: number;
  email: string;
  fullName: string;
  klasse: string;
  /** Unix epoch seconds when the 15-day session expires. */
  tokenExp: number;
}

export const STUDENT_ME_KEY = ['student-me'] as const;

/** Mirrors `useAuthMe` but for the strictly-separate student session. */
export function useStudentMe(opts: { enabled?: boolean } = {}) {
  return useQuery<StudentMe, Error>({
    queryKey: STUDENT_ME_KEY,
    queryFn: () => apiFetch<StudentMe>('/student/me'),
    enabled: opts.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
